import { apiSlice } from './apiSlice';

export interface TNItemDto {
  cargoId?: number;
  name: string;
  places: number;
  weightKg?: number;
  volumeM3?: number;
  packageType?: string;
  notes?: string;
}

export interface TNDto {
  id: number;
  number: string;
  date: string;
  status: 'draft' | 'ready' | 'printed' | 'signed';
  routeId?: number;
  applicationId?: number;
  shipperId?: number;
  // New fields: p.1 expeditor flag and p.8 shipper
  p1IsExpeditor?: boolean;
  p8ShipperId?: number;
  p12Empty?: boolean;
  consigneeId?: number;
  carrierId?: number;
  driverId?: number;
  vehicleId?: number;
  /** Прицеп (категория TRAILER), опционально. */
  trailerVehicleId?: number | null;
  clientId?: number;
  consigneeNamePrefix?: string | null;
  accompanyingDocuments?: string | null;
  // Optional denormalized fields that backend may return
  shipperName?: string;
  consigneeName?: string;
  driverName?: string;
  shipper?: { id: number; name: string };
  consignee?: { id: number; name: string };
  driver?: { id: number; fullName: string };
  trailerVehicle?: { id: number; registrationNumber: string; vehicleCategory?: string };
  loadingAddress?: string;
  unloadingAddress?: string;
  totalPlaces?: number;
  totalWeightKg?: number;
  totalVolumeM3?: number;
  freightAmount?: number;
  items?: TNItemDto[];
}

export const tnApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTNList: builder.query<{ items: TNDto[]; total: number; page: number; limit: number }, { page?: number; limit?: number; search?: string; status?: string; routeId?: number; applicationId?: number }>({
      query: (params = {}) => {
        const sp = new URLSearchParams();
        if (params.page) sp.append('page', String(params.page));
        if (params.limit) sp.append('limit', String(params.limit));
        if (params.search) sp.append('search', params.search);
        if (params.status) sp.append('status', params.status);
        if (params.routeId) sp.append('routeId', String(params.routeId));
        if (params.applicationId) sp.append('applicationId', String(params.applicationId));
        return { url: `/tn?${sp.toString()}`, method: 'GET' };
      },
      transformResponse: (r: any) => r,
      providesTags: ['TN']
    }),
    getTNById: builder.query<TNDto, number>({
      query: (id) => ({ url: `/tn/${id}`, method: 'GET' }),
      transformResponse: (r: any) => r,
      providesTags: (result, error, id) => [{ type: 'TN', id }]
    }),
    createTN: builder.mutation<TNDto, Partial<TNDto> & { routeId?: number; applicationId?: number; consigneeNamePrefix?: string | null; accompanyingDocuments?: string | null }>({
      query: (body) => ({ url: '/tn', method: 'POST', body }),
      transformResponse: (r: any) => r,
      invalidatesTags: ['TN', 'Route', 'Application']
    }),
    updateTN: builder.mutation<TNDto, { id: number; data: Partial<TNDto> & { items?: TNItemDto[]; consigneeNamePrefix?: string | null; accompanyingDocuments?: string | null } }>({
      query: ({ id, data }) => ({ url: `/tn/${id}`, method: 'PUT', body: data }),
      transformResponse: (r: any) => r,
      invalidatesTags: (result, error, { id }) => [{ type: 'TN', id }, 'TN']
    }),
    deleteTN: builder.mutation<{ success: boolean }, number>({
      query: (id) => ({ url: `/tn/${id}?confirm=true`, method: 'DELETE' }),
      transformResponse: (r: any) => r,
      invalidatesTags: ['TN']
    })
  })
});

export const { useGetTNListQuery, useGetTNByIdQuery, useCreateTNMutation, useUpdateTNMutation, useDeleteTNMutation } = tnApi;





